import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  // Validate source field is provided
  if (!properties.sourceField || properties.sourceField.trim() === '') {
    errors.push({ key: 'sourceField', message: 'Source field is required' });
  }

  // Validate extractions have at least one entry
  const extractions = properties.extractions?.values;
  if (!extractions || !Array.isArray(extractions) || extractions.length === 0) {
    errors.push({ key: 'extractions', message: 'At least one extraction is required' });
  } else {
    // Validate each extraction
    extractions.forEach((extraction: any, index: number) => {
      if (!extraction.key || extraction.key.trim() === '') {
        errors.push({ key: `extractions.values.${index}.key`, message: `Extraction ${index + 1}: Key is required` });
      }

      const mode = properties.extractionMode;
      if (mode === 'cssSelector') {
        if (!extraction.selector || extraction.selector.trim() === '') {
          errors.push({ key: `extractions.values.${index}.selector`, message: `Extraction ${index + 1}: CSS Selector is required` });
        }
      } else if (mode === 'xpath') {
        if (!extraction.xpath || extraction.xpath.trim() === '') {
          errors.push({ key: `extractions.values.${index}.xpath`, message: `Extraction ${index + 1}: XPath is required` });
        }
      }

      if (extraction.returnValue === 'attribute' && (!extraction.attribute || extraction.attribute.trim() === '')) {
        errors.push({ key: `extractions.values.${index}.attribute`, message: `Extraction ${index + 1}: Attribute name is required` });
      }
    });
  }

  return {
    valid: errors.length === 0,
    errors
  };
}
